import React, { useCallback, useRef, useState, useEffect } from "react";
import AnteButton from "../Buttons/AnteButton";
import CancelHandButton from "../Buttons/CancelHandButton";
import EndHandButton from "../Buttons/EndHandButton";
import PassCommunityModal from "../Dialogs/PassCommunityModal";
import PassDealPopUp from "../Dialogs/PassDealPopup";
import { DealCards } from "../../common/game/GameControl";
import { useSelector } from "react-redux";
import { selectIsSessionActive } from "../../slice/gameStateSlice";

const DealerPanel = ({ showDealerPrompt = false }) => {
  const [cardDealType, setCardDealType] = useState(0);
  const [passCommunityModalOpen, setPassCommunityModalOpen] = useState(false);
  const [passDealPopUpOpen, setPassDealPopUpOpen] = useState(false);
  const [showAnte, setShowAnte] = useState(true);
  const gameState = useSelector((state) => state.gameState);
  const user = useSelector((state) => state.auth.user);
  // DC-MULTITAB: Check if session is active
  const isSessionActive = useSelector(selectIsSessionActive);

  const txtAnteRef = useRef(null);
  const DealValueRef = useRef(null);

  // Reset Ante UI when a new hand starts (GameHand increments on cancel or end)
  useEffect(() => {
    setShowAnte(true);
  }, [gameState.GameHand]);

  // DC-FE-DEALERPANEL-HOOKS-FIX-001: All hooks must be called unconditionally (before any early returns)
  // When you click deal button
  const dealCardToPlayer = useCallback(
    (index) => {
      try {
        // Get Number of card to pass
        const NumOfCard = parseInt(DealValueRef.current.value);

        if (isNaN(NumOfCard)) {
          alert("Input correct number");
          return;
        }

        if (NumOfCard <= 0) {
          alert("Cannot deal zero or less cards");
          return;
        }

        DealCards(
          user.Id,
          gameState.GameCode,
          DealValueRef.current.value,
          index,
          0,
          cardDealType,
          () => {
            setPassCommunityModalOpen(false);
            DealValueRef.current.value = "";
          }
        );
      } catch (err) {
        console.error("Error in dealCardToPlayer:", err);
      }
    },
    [cardDealType, gameState.GameCode, user.Id]
  );

  const dealCardToCommunity = useCallback(
    (communityIndex) => {
      DealCards(
        user.Id,
        gameState.GameCode,
        DealValueRef.current.value,
        communityIndex,
        1,
        cardDealType,
        () => {
          setPassCommunityModalOpen(false);
        }
      );
    },
    [cardDealType, gameState.GameCode, user.Id]
  );

  const PassDealEventHandler = useCallback((ev) => {
    setPassDealPopUpOpen(true);
  }, []);

  // DC-MULTITAB: If session is inactive, show lockout message instead of dealer controls
  // (This early return is AFTER all hooks have been called)
  if (!isSessionActive) {
    return (
      <div className="PlayerDealer dc-session-inactive p-3 text-center text-muted">
        Session inactive - dealer controls disabled
      </div>
    );
  }

  return (
    <>
      <div className="PlayerDealer" data-testid="dealer-panel">
        {/* DC-UX-POT-IS-GOOD-S03: Dealer-only prompt when pot is good */}
        {showDealerPrompt && (
          <div
            className="text-center mb-2 p-2 bg-info text-white rounded"
            style={{ fontSize: '0.9rem' }}
            data-testid="dealer-next-card-prompt"
          >
            Deal next card
          </div>
        )}
        <div className="row align-items-center border-primary border-bottom mb-1 justify-content-between p-3 p-sm-0">
          <div className="col-2 col-sm-2 text-center  h-100">
            {showAnte && (
              <input
                id="txtAnte"
                className="mt-0"
                ref={txtAnteRef}
                autoComplete="off"
              />
            )}
            <AnteButton txtAnteRef={txtAnteRef} showAnte={showAnte} setShowAnte={setShowAnte} />
          </div>
          <div className="col-5 col-sm-3 text-center  h-100">
            <span>Deal</span>
            <input
              id="DealValue"
              className="p-0"
              ref={DealValueRef}
              autoComplete="off"
            />
            <span>Cards</span>
          </div>
          <div className="col-5 col-sm-3 text-center  h-100">
            <div>
              <input
                autoComplete="off"
                type="radio"
                className="w-25 d-inline"
                id="faceup"
                value="public"
                name="CardDealType"
                defaultChecked
                onClick={() => setCardDealType(0)}
              />
              <label htmlFor="faceup" className="w-50 btn btn">
                up
              </label>
            </div>
            <div className="d-inline-block; mt-2">
              <input
                autoComplete="off"
                type="radio"
                className="w-25 d-inline"
                id="facedown"
                value="private"
                name="CardDealType"
                onClick={() => setCardDealType(1)}
              />
              <label htmlFor="facedown" className="w-50 btn btn">
                down
              </label>
            </div>
          </div>
          <div className="col-2 col-sm-1 text-center  h-100">to</div>
          <div className="col-8 col-sm-3 text-center  h-100">
            <div
              className="CardDealPlayer"
              style={{
                display: "inline-grid",
                fontSize: "12px",
              }}
            >
              <button
                type="button"
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontSize: "inherit",
                  color: "inherit",
                  userSelect: "none",
                  WebkitUserSelect: "none",
                  WebkitTouchCallout: "none",
                }}
                onClick={() => dealCardToPlayer(-1)}
              >
                All
              </button>
              <button
                type="button"
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontSize: "inherit",
                  color: "inherit",
                  userSelect: "none",
                  WebkitUserSelect: "none",
                  WebkitTouchCallout: "none",
                }}
                onClick={() => setPassCommunityModalOpen(true)}
              >
                Community
              </button>
              {gameState.FilteredPlayers.map(({ PlayerName }, index) => {
                return (
                  <button
                    type="button"
                    key={index}
                    style={{
                      background: "none",
                      border: "none",
                      padding: 0,
                      textDecoration: "underline",
                      cursor: "pointer",
                      fontSize: "inherit",
                      color: "inherit",
                      userSelect: "none",
                      WebkitUserSelect: "none",
                      WebkitTouchCallout: "none",
                    }}
                    onClick={() => dealCardToPlayer(index)}
                  >
                    {PlayerName}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
        {/* Dealer-only hand controls (DC-FE-SWAMP-UX-TRIAGE-001) */}
        <div className="p-2 d-flex justify-content-center flex-wrap gap-2">
          <CancelHandButton />
          <EndHandButton />
          <button
            className="btn PassDeal me-2 mt-2"
            data-toggle="tooltip"
            data-html="true"
            title="click to view options"
            onClick={PassDealEventHandler}
          >
            Pass Deal
          </button>
        </div>
      </div>
      <PassCommunityModal
        open={passCommunityModalOpen}
        setOpen={setPassCommunityModalOpen}
        dealCardToCommunity={dealCardToCommunity}
      />
      <PassDealPopUp open={passDealPopUpOpen} setOpen={setPassDealPopUpOpen} />
    </>
  );
};

export default DealerPanel;
